import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

import { Button, Modal, Icon } from 'components/Elements'
import { usePopup } from 'hooks'
import { JobBulkInvite } from 'features/job/components/JobInvite'

export const BulkInviteControl = ({
  disabled = false,
  className = '',
  onSuccess,
  filters,
  job,
  blocked = false,
  jobSelect,
}) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const { visible, open, close } = usePopup()

  const onSubmitSuccess = data => {
    close()

    onSuccess && onSuccess(data)
  }

  const onClick = () => {
    if (blocked) {
      navigate('/billing/subscription')
    } else {
      open()
    }
  }

  return (
    <>
      <div>
        <Button
          className={className}
          onClick={onClick}
          disabled={disabled}
          size={'sm'}
          width={'w-sm'}
          rightIcon={blocked ? <Icon name={'blocked'} className={'font-size-14'} /> : null}
        >
          {t('invite_all_matched_candidates')}
        </Button>
      </div>

      <Modal visible={visible} centered onClose={close} title={t('invite_all_matched_candidates')}>
        <JobBulkInvite
          job={job}
          filters={filters}
          onSuccess={onSubmitSuccess}
          jobSelect={jobSelect}
        />
      </Modal>
    </>
  )
}

BulkInviteControl.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onSuccess: PropTypes.func,
  filters: PropTypes.object,
  job: PropTypes.object,
  blocked: PropTypes.bool,
  jobSelect: PropTypes.bool,
}
